import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PremiumPlanBox from './PremiumPlanBox';
import SinglePricePremiumPlanBox from './SinglePricePremiumPlanBox';
import FreeAndPremiumCompareTable from '~/components/FreeAndPremiumCompareTable';
import withI18next from '~/../hocs/_withI18next';
import Config from '~/config';
import {
  makeSelectIsAuthenticated,
  makeSelectProfile,
} from '~/containers/AuthProvider/selectors';
// import { openModal } from '~/containers/LoginModal/actions';
import {
  closeModal as closePaymentModal,
  openModal as openPaymentModal,
  selectedPremium,
  selectedSinglePremium,
  createPaymentIntentOfSinglePremium,
  initCountdown,
  updateCountdown,
} from '~/containers/PaymentModal/actions';
import {
  makeSelectCountdownDiscount,
  makeSelectCoupon,
} from '~/containers/PaymentModal/selectors';
import { locales } from '~/utils';
import { OPEN_MODAL } from '~/containers/ErrorMessageModal/constants';
import themeVariables from '~/shared/themeVariables';

const roles = Config.getRoles();

@withI18next()
class PricePremiumComponent extends React.Component {
  // componentDidMount() {
  //   const { initCountdown } = this.props;
  //   initCountdown();
  // }

  onRegisterPremium = (plan) => {
    if (!this.props.isAuthenticated) {
      // this.props.openLoginModal();
      window.location.href = `${Config.ssoServerUrl}/login?lang=${
        this.props.lng
      }&serviceURL=${encodeURIComponent(
        process.browser ? window.location.href : '',
      )}`;
    } else {
      if (this.props.profile.role === roles.CREATOR) {
        this.onShowModalWarning();
        return;
      }
      if (Config.isChina()) {
        this.props.createPaymentIntentOfSinglePremiumPlan(plan);
      } else {
        this.props.selectedPremium(plan);
      }
      this.props.openPaymentModal();
    }
  };

  onShowModalWarning = () => {
    const { t } = this.props;
    this.props.showModalWarning({
      switchAccount: true,
      title: t('You can’t download'),
      description: t('Please logout and use downloader account.'),
    });
  };

  renderSubscriptionPremiumPlan = () => {
    const { plans, t, lng, countdown, updateCountdown, coupon } = this.props;

    return (
      <>
        {[plans.ONE_YEAR, plans.MONTHLY].map((plan, index) => {
          if (plan) {
            const currentPlan = locales.filterPriceByLanguage(
              plan.pricesByCurrency,
              lng,
            );

            if (plan.plan == 'ONE_YEAR' && currentPlan) {
              return (
                <PremiumPlanBox
                  currentPlan={currentPlan}
                  typePlan="ONE_YEAR"
                  t={t}
                  key={index}
                  countdown={countdown}
                  updateCountdown={updateCountdown}
                  onRegisterPremium={this.onRegisterPremium}
                  coupon={countdown && countdown.coupon}
                />
              );
            }

            if (plan.plan == 'MONTHLY' && currentPlan) {
              return (
                <PremiumPlanBox
                  currentPlan={currentPlan}
                  typePlan="MONTHLY"
                  t={t}
                  key={index}
                  countdown={countdown}
                  updateCountdown={updateCountdown}
                  onRegisterPremium={this.onRegisterPremium}
                />
              );
            }
          } else {
            return null;
          }
        })}
      </>
    );
  };

  renderSinglePremmiumPlan = () => {
    const { singlePricePremiums, t } = this.props;
    return (
      <>
        <SinglePricePremiumPlanBox
          currentSinglePremium={singlePricePremiums.ONE_YEAR}
          onRegisterPremium={this.onRegisterPremium}
        />
        <SinglePricePremiumPlanBox
          currentSinglePremium={singlePricePremiums.TWO_YEAR}
          onRegisterPremium={this.onRegisterPremium}
        />
        <SinglePricePremiumPlanBox
          currentSinglePremium={singlePricePremiums.THREE_YEAR}
          onRegisterPremium={this.onRegisterPremium}
        />
      </>
    );
  };

  renderPremiumPlanByCurrentRegion = () => {
    if (Config.isChina()) {
      return this.renderSinglePremmiumPlan();
    }
    return this.renderSubscriptionPremiumPlan();
  };

  render() {
    const { lng, t, plans, profile, singlePricePremiums } = this.props;

    return (
      <div className="price-premium-container">
        {Config.serviceType !== 'design_ac' && (
          <div className="price-premium-wrapper">
            <FreeAndPremiumCompareTable />
            {profile.role != Config.getRoles().PREMIUM && (
              <div className="price-premium-card">
                {this.renderPremiumPlanByCurrentRegion()}
              </div>
            )}
          </div>
        )}
        {Config.serviceType === 'design_ac' &&
          profile.role != Config.getRoles().PREMIUM && (
            <div className="container pt50 pb50">
              <div
                className={
                  profile.role != Config.getRoles().PREMIUM
                    ? 'col-lg-6'
                    : 'col-lg-12'
                }
              >
                <FreeAndPremiumCompareTable />
              </div>
              <div className="row">
                <div className="col-lg-6">
                  {this.renderPremiumPlanByCurrentRegion()}
                </div>
              </div>
            </div>
          )}
        <style jsx>
          {`
            .price-premium-container {
              justify-content: center;
              width: 100%;
              display: flex;
            }

            .price-premium-wrapper {
              display: flex;
              width: 80%;
            }

            .price-premium-card {
              margin-left: 32px;
              min-width: 50%;
            }

            @media (max-width: ${themeVariables.breakpoints.tabletL
                .maxWidth}px) {
              .price-premium-wrapper {
                flex-direction: column;
                justify-content: center;
                align-items: center;
              }

              .price-premium-card {
                margin-left: 0;
                width: 100%;
                margin-top: 24px;
              }
            }

            @media (max-width: ${themeVariables.breakpoints.mobile
                .maxWidth}px) {
              .price-premium-wrapper {
                width: 100%;
              }
              .price-premium-container {
                padding: 0 10px;
              }

              .price-premium-wrapper {
                flex-direction: column-reverse;
              }
              .price-premium-card {
                width: 100%;
                margin-top: 0;
              }
            }
          `}
        </style>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  isAuthenticated: makeSelectIsAuthenticated(),
  profile: makeSelectProfile(),
  countdown: makeSelectCountdownDiscount(),
  coupon: makeSelectCoupon(),
});
const mapDispatchToProps = (dispatch) => ({
  initCountdown: () => dispatch(initCountdown()),
  updateCountdown: (remainingDuration) =>
    dispatch(updateCountdown(remainingDuration)),
  // openLoginModal: () => dispatch(openModal()),
  openPaymentModal: () => dispatch(openPaymentModal()),
  closePaymentModal: () => dispatch(closePaymentModal()),
  selectedPremium: (plan) => dispatch(selectedPremium(plan)),
  showModalWarning: (params) =>
    dispatch({
      type: OPEN_MODAL,
      switchAccount: params.switchAccount,
      title: params.title,
      description: params.description,
    }),
  selectedSinglePremium: (plan) => dispatch(selectedSinglePremium(plan)),
  createPaymentIntentOfSinglePremiumPlan: (plan) =>
    dispatch(createPaymentIntentOfSinglePremium(plan)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PricePremiumComponent);
